<template>
    <v-footer :absolute="true">
      <div class="footer">
        <div class="content">
          <a href="http://skanzen.hu/hu"><v-img :src="require('@/assets/images/footer_logo.png')" class="footer-logo" /></a>
          <a href="http://skanzen.hu/hu/kapcsolat" class="footer-link">Kapcsolat</a><label> | </label>
          <a href="http://skanzen.hu/hu/impresszum" class="footer-link">Impresszum</a>
          <label> | </label>
          <a href="http://skanzen.hu/hu/adatvedelmi-szabalyzat"
                       class="footer-link">Adatvédelmi szabályzat</a><label> | </label>
          <a href="http://skanzen.hu/hu/sajtoszoba" class="footer-link">Sajtószoba</a>
          <label> | </label>
          <a href="http://skanzen.hu/hu/kozerdeku-informaciok"
                       class="footer-link">Közérdekű információk</a>
          <label>Skanzen &copy; {{ new Date().getFullYear() }} Minden jog fenntartva.</label>
          <a href="http://playdead.hu"><v-img :src="require('@/assets/images/PD_logo.png')" class="pd-logo" /></a>
        </div>
      </div>
      <div class="red-line"></div>
    </v-footer>
</template>

<script>
export default {
  name: 'Footer',
};
</script>

<style scoped>

</style>
